import { contentConstants } from "../constants/content.constants";

/**
 * Checks if the upload limit has been reached.
 * @param {number} currentCount - The current number of uploads.
 * @param {number} maxLimit - The maximum allowed uploads.
 * @returns {boolean} True if the limit is reached or exceeded, false otherwise.
 */
export function checkUploadLimit({
    currentCount, 
    maxLimit = contentConstants.UPLOAD_LIMIT
}) {

    const isLimitReached = currentCount > maxLimit;
    
    if(isLimitReached) {
        alert(`You have reached the limit of ${maxLimit} per upload.`);
    }
    
    return isLimitReached;
}